/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Travel_Start_Eta_Before_EventInputs */

const en_travel_start_eta_before_event = /** @type {(inputs: Travel_Start_Eta_Before_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA cannot be before travel start time.`)
};

const ja_travel_start_eta_before_event = /** @type {(inputs: Travel_Start_Eta_Before_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETAは出発時刻より前にできません。`)
};

const fr_travel_start_eta_before_event = /** @type {(inputs: Travel_Start_Eta_Before_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ETA ne peut pas être antérieure au début du trajet.`)
};

const de_travel_start_eta_before_event = /** @type {(inputs: Travel_Start_Eta_Before_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA darf nicht vor der Abfahrtszeit liegen.`)
};

/**
* | output |
* | --- |
* | "ETA cannot be before travel start time." |
*
* @param {Travel_Start_Eta_Before_EventInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const travel_start_eta_before_event = /** @type {((inputs?: Travel_Start_Eta_Before_EventInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Travel_Start_Eta_Before_EventInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_travel_start_eta_before_event(inputs)
	if (locale === "ja") return ja_travel_start_eta_before_event(inputs)
	if (locale === "fr") return fr_travel_start_eta_before_event(inputs)
	return de_travel_start_eta_before_event(inputs)
});